import { observable } from "mobx";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class TransferPaymentRestrictionsResponse {
  /**
   * Indicates the number of days by which the validity must be postponed in order to choose transfer payment.
   */
  @observable
  earliestPossibleValidSinceDaysBefore!: number;

  /**
   * Indicates earliest possible valid since date for which transfer payment can be chosen.
   */
  @observable
  @Type(() => Date)
  earliestPossibleValidSinceDate!: Date;
}
